
$(".input_tel").intlTelInput({ 
  utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.8/js/utils.js",
});
$(".input_tel").intlTelInput("setCountry", "ma");
$(document).on('ready', function () {
  $(".iti--allow-dropdown").addClass('w-100');
  function getCode() {
    var title = $('.iti__selected-flag').attr('title');
    var index = title.indexOf('+');
    return title.substr(index);
  }

  function getnumber() {
    var phone = $('.input_tel').val();
    if (phone.substr(0, 1) == 0) {
      phone = phone.substr(1);
    }
    phone = phone.replace("-", "");
    return phone;
  }
  $("#add_order").on('click', function () {
    reset();
    parse_json();
  });
  
  $(".single-option-selector").on('change', function () {
    setTimeout(function(){
      var text = $("#AddToCartText-product-template").text();
      if(text.includes("Sold out")){
        $("#add_order").attr("disabled",true);
        $("#add_order").text("مخزون المنتج منتهي");
      }else{
        $("#add_order").attr("disabled",false);
        $("#add_order").text("أطلب المنتج الأن"); 
      }
    },300);
  });
   
  $("#form-order").on('submit', function () {
    var variant_id = $("#ProductSelect-product-template").val();
    var price =$('.price-item--sale')[0].textContent.trim().replace(" dh","");
    var product = "ST_"+$(".product_title").text();
    var full_number = getCode() + getnumber();
    var data = {
      name: $("#name").val(),
      city: $("#city").val(),
      address: $("#address").val(),
      product: product,
      phone: full_number.replace("+212",""),
      price: price,
    };
    console.log(data);
    spinner(); 
    send_data(data);
    return false;
  });

  function reset() {
    $("#spinner").addClass("d-none");
    $("#success").addClass("d-none");
    $("#error").addClass("d-none");
    $("#order_form").removeClass("d-none");
  }

  function spinner() {
    $("#spinner").removeClass("d-none");
    $("#order_form").addClass("d-none");
  }

  function success() {
    $("#success").removeClass("d-none");
    $("#spinner").addClass("d-none");
  }
 

  function error() {
    $("#error").removeClass("d-none");
    $("#spinner").addClass("d-none");
  }

  function parse_json() {
    var selected_variant = $("#ProductSelect-product-template").val();
    var json = JSON.parse($("#ProductJson-product-template").text());
    var variant = json["variants"];
    
    var image = json["featured_image"];
    image = image.replace(".png", "_300x300.png");
    image = image.replace(".jpg", "_300x300.jpg");
    image = image.replace(".jpeg", "_300x300.jpeg");

    $("#image_product").attr("src", image);
    for (var i = 0; i < variant.length; i++) {
      var vari = variant[i];
      if (vari["id"] == selected_variant) {
        $(".product_title").text(vari["name"]);
      }
    }
  }

  function send_data(data) {
//      {
//                 name,
//                 address,
//                 city,
//                 phone,
//                 price,
//                 product,
//             }
     $.ajax({
            url: "https://ghizlane.net/site-order",
            type: "POST",
            dataType: 'jsonp',
            data:data,
            success: function (data) {
//               fbq('track', 'Purchase');
              //328716290583979
              //253466065360649
//               console.log(getPixValue());
//               fbq('init', getPixValue());
//               fbq('trackSingle', getPixValue(), 'Purchase', {
//                       value: 17,
//                       currency: 'USD',
//                 });
                success();
//                 console.log(data)
            },
            error: function (xhr, ajaxOptions, thrownError) {
                console.log(thrownError)
                error();
            }
        });

//     $.ajax({
//       url: "http://floating-springs-62380.herokuapp.com/add_new_order",
//       type: "POST",
//       dataType: 'jsonp',
//       data: data,
//       // processData: false,
//       // contentType: 'application/json',
//       // CrossDomain: true,
//       // async: false,
//       success: function (data) {
//         success();
//       },
//       error: function (xhr, ajaxOptions,
//         thrownError) { //Add these parameters to display the required response
//         error();
//       }
//     });
  }
});